import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = () => ({
	root: {
		marginLeft: 18,
		fontSize: 16,
		fontWeight: 'bold',
		marginTop: 30,
		padding: '10px 0',
	},
	requiredIndicator: {
		fontSize: '60%',
		verticalAlign: 'super',
		marginLeft: 3
	}
});

@withStyles(styles)
class FormLabel extends Component {
	render() {
		const { classes, children, className, required } = this.props;
		const requiredIndicator = <span className={classes.requiredIndicator}>*</span>;
		return (<Typography title={required && localize('required-field')} className={classNames(classes.root, className)}>
			{children}{required && requiredIndicator}
		</Typography>);
	}
}

FormLabel.propTypes = {
	children: PropTypes.string.isRequired,
	classes: PropTypes.object,
	className: PropTypes.string,
	required: PropTypes.bool
};

export default FormLabel;



// WEBPACK FOOTER //
// ./src/components/FormLabel/index.js